export default "__VITE_ASSET__YXu_CR16__"